import { Badge } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { KHONG_CO, ngayVN } from '../../../../lib/dinh-dang';
import { BADGE_VINH_VIEN, LOAI_LICENSE_HIEN, TRANG_THAI_LICENSE_HIEN, TRUY_CAP_LICENSE } from '../../constants';
import { thietBiDangBind, truyCap, type DongUserLicense } from '../../nghiep-vu/license';
import type { LicenseRpa, LoaiLicense, TrangThaiUserLicense } from '../../types';

export function BadgeTrangThaiLicense({ status }: { status: TrangThaiUserLicense | 'none' }) {
  const { t } = useT();
  const v = TRANG_THAI_LICENSE_HIEN[status];
  return (
    <Badge variant={v.variant} className="whitespace-nowrap">
      {t(v.khoa)}
    </Badge>
  );
}

export function BadgeLoaiLicense({ loai }: { loai: LoaiLicense }) {
  const { t } = useT();
  const v = LOAI_LICENSE_HIEN[loai];
  return (
    <Badge variant={v.variant} className="whitespace-nowrap">
      {t(v.khoa)}
    </Badge>
  );
}

/** Ngày hết hạn hoặc nhãn "Không thời hạn". */
export function HanLicense({ license }: { license: Pick<LicenseRpa, 'is_lifetime' | 'expired_at'> }) {
  const { t } = useT();
  if (license.is_lifetime) {
    return (
      <Badge variant={BADGE_VINH_VIEN} className="whitespace-nowrap">
        {t('rpaLicense.vinhVien')}
      </Badge>
    );
  }
  return <span className="whitespace-nowrap tabular-nums">{ngayVN(license.expired_at)}</span>;
}

/** Quyền chạy thực tế trên OpenCore; lỗi đồng bộ kèm câu lỗi của máy chủ ở `title`. */
export function BadgeTruyCap({ dong }: { dong: DongUserLicense }) {
  const { t } = useT();
  const k = truyCap(dong);
  if (!k) return <span className="text-content-muted">{KHONG_CO}</span>;
  const v = TRUY_CAP_LICENSE[k];
  const badge = (
    <Badge variant={v.variant} className="whitespace-nowrap">
      {t(v.khoa)}
    </Badge>
  );
  return k === 'syncError' && dong.license?.access_sync_error ? <span title={dong.license.access_sync_error}>{badge}</span> : badge;
}

/** Máy đang bind: tên máy và HWID rút gọn; danh sách thiết bị không đọc được thì nói ra, không hiện "chưa bind". */
export function OThietBi({ license }: { license: LicenseRpa | null }) {
  const { t } = useT();
  if (!license) return <span className="text-content-muted">{KHONG_CO}</span>;
  if (license.devicesStatus === 'unavailable') return <span className="text-xs text-warning-700">{t('rpaLicense.thietBiKhongDoc')}</span>;
  const d = thietBiDangBind(license);
  if (!d) {
    return (
      <Badge variant="neutral" className="whitespace-nowrap">
        {t('rpaLicense.chuaBind')}
      </Badge>
    );
  }
  return (
    <div className="min-w-0 max-w-[12rem] leading-tight">
      <p className="truncate" title={d.machineName || d.deviceName}>
        {d.machineName || d.deviceName || KHONG_CO}
      </p>
      <code className="text-2xs text-content-muted">{d.hwidShort}</code>
    </div>
  );
}
